import { render, staticRenderFns } from "./newsPage.vue?vue&type=template&id=add44eea&"
import script from "./newsPage.vue?vue&type=script&lang=js&"
export * from "./newsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports